'use strict';

(function () {
	angular.module('onboarding.services')
		.factory('carrierDocumentsService', carrierDocumentsService);

	var extensionErrorMessage = 'Document format is invalid. Please make sure to upload file in the following format: .doc, .docx, .gif, .jpeg, .jpg, .pdf, .png, .tif, .tiff, .xls, or .xlsx.';
	var maxFileSizeErrorMessage = 'Document is too large for upload. Only files under 10mb allowed. Please make sure to select file under 10mb.';
	var documentIsEmpty = 'Your document is empty. Please make sure to select valid document.';
	var sameNameErrorMessage = 'Document with same name already uploaded. Please give this document a unique name, and then upload again.';

	var carrierRegistrationService,
		ngFileUpload;

	carrierDocumentsService.$inject = ['carrierRegistrationService', 'Upload'];

	function carrierDocumentsService(_carrierRegistrationService_, _ngFileUpload_) {

		carrierRegistrationService = _carrierRegistrationService_;
		ngFileUpload = _ngFileUpload_;
		
		return {
			validateFile: validateFile,
			validateFleetDocument: validateFleetDocument,
			getBase64DataUrl: getBase64DataUrl,
			getResult: getResult,
			getDocumentsByType: getDocumentsByType,
			uploadDocument: uploadDocument,
			editDocument: editDocument
		};

		function validateFile(file) {
			if (!file) {
				return getResult(false, 'File is invalid.');
			}

			var validMimeTypes = [
				'application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
				'application/msword', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				'application/vnd.ms-excel', 'application/vnd.ms-word', 'image/tiff', 'image/png', 'image/jpeg',
				'image/gif'
			];

			if (validMimeTypes.indexOf(file.type) === -1) {
				return getResult(false, extensionErrorMessage);
			}

			if (file.size >= 10485760) {
				return getResult(false, maxFileSizeErrorMessage);
			}

			if (file.size === 0) {
				return getResult(false, documentIsEmpty);
			}

			return getResult(true);
		}

		function validateFleetDocument(loadedFiles, file) {
			var validationResult = validateFile(file);
			if (!validationResult.succeeded) {
				return validationResult;
			}

			if (loadedFiles && loadedFiles.some(function(doc) { return doc.documentName == file.name; } )) {
				return getResult(false, sameNameErrorMessage);
			}

			return getResult(true);
		}

		function uploadDocument(file, carrierId) {
			if (file.base64 && file.documentName) {
				var fileName = file.documentName;
				var fileExtension = fileName.split('.').pop();
				fileName = fileName.substring(0, fileName.length - (fileExtension.length + 1)); //trim off extension

				return carrierRegistrationService.insertCarrierDocument(fileName,
					fileExtension,
					file.mimeType,
					file.base64,
					file.description,
					file.documentType,
					file.documentName,
					carrierId);
			}
		}

		function editDocument(document, carrierId) {
			if (document.documentName) {
				if (!document.documentStatus) {
					document.documentStatus = 'ACTIVE';
				}

				return carrierRegistrationService.updateCarrierDocument(document.documentId,
					document.description,
					document.documentType,
					document.documentName,
					document.documentStatus,
					carrierId);
			}
		}

		function getBase64DataUrl(file) {
			return ngFileUpload.base64DataUrl(file, false);
		}

		function getResult(succeeded, errorMessage) {
			return {
				succeeded: succeeded,
				errorMessage: errorMessage || ''
			};
		}

		function getDocumentsByType(documents, type) {
			var docs = [];
			for (var i = 0; i < documents.length; i++) {
				if (documents[i].documentType === type) {
					docs.push(documents[i]);
				}
			}

			return docs;
		}
	}
})();
